export default __webpack_public_path__ + "assets/schick_banner_350x160-dc4fd2e169ab293faa0625380b5ce412.jpg";